import {cDateField}     from "../../components/date-field/date-field";
import {cUtil}          from "../../functions/util";
import {cOrderListItem} from "../../components/order-list-item/order-list-item";

export class cCart implements OrderItemContainer, DateFieldTop {

  div_messagesErrors  = document.createElement('div');
  div_itemsContainer  = document.createElement('div');
  button_partDelivery = document.createElement('button');
  button_updateCart   = document.createElement('button');
  button_toCheckout   = document.createElement('button');
  button_updateCart2  = document.createElement('button');
  button_sameDate     = document.createElement('button');
  input_submitData    = document.createElement('input');

  div_cartTotals      = document.querySelector('.c-cart-totals')         as HTMLElement;
  dl_cartTotals       = document.querySelector('.c-cart-totals dl')      as HTMLDListElement;
  dt_weight           = document.createElement('dt');
  dd_weight           = document.createElement('dd');
  span_weightCa       = document.createElement('span');
  span_weightAmount   = document.createElement('span');

  form                = document.querySelector('.woocommerce-cart-form') as HTMLFormElement;
  parent              = document.querySelector('.woocommerce-cart-form') as HTMLElement;
  cartItemDataElm     = document.querySelector('script.c-cart-data')     as HTMLScriptElement;          
  cartItemElms        = document.querySelectorAll('.c-item')             as unknown as HTMLElement[];


  commonDeliveryDate : cDateField;
  input              : CartData;
  items              : cOrderListItem[] = [];
  validDates         : string[] = [];
  errors             : Set<{msg: string, type: 'alert'|'warning'|'info'|'success'|'warning-date'}>;

  constructor() {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    this.errors = new Set();
    this.input  = JSON.parse(this.cartItemDataElm.textContent) as CartData;

    // ---- Structure ----
    this.parent.append(this.div_messagesErrors);

    const deliveryDateLabel = 
      cUtil.customerPickUp() 
      ? __('Abholdatum', 'custom')
      : __('Lieferdatum', 'custom');

    const deliveryDatePlaceholder = 
      cUtil.customerPickUp() 
      ? __('Teilabholungen', 'custom')
      : __('Teillieferungen', 'custom');
    
    this.commonDeliveryDate = new cDateField({
      validDates      : ['1970-01-01'], 
      initDate        : '',
      label           : deliveryDateLabel,
      placeholder     : deliveryDatePlaceholder,
      parentElm       : this.parent, 
      parentObj       : this,
      eventDefault    : 'commonDeliveryDate',
      cssClass        : 'c-common-delivery-date',
      emptyAllowed    : true,
    });
    
    this.parent.append(this.button_partDelivery);
    this.parent.append(this.button_updateCart);
    this.parent.append(this.input_submitData);

    this.parent.append(this.div_itemsContainer);
      for(const item of this.input.items) {
        this.items.push(new cOrderListItem(
          item, 
          this.div_itemsContainer, 
          this.input.nonce, 
          this,
          'cart'
        ));
      }

    this.div_cartTotals.append(this.button_updateCart2);
    this.div_cartTotals.append(this.button_toCheckout);

    this.dl_cartTotals.prepend(this.dd_weight);
      this.dd_weight.append(this.span_weightCa);
      this.dd_weight.append(this.span_weightAmount);
    this.dl_cartTotals.prepend(this.dt_weight);

    if (this.input.items.length === 0) return;

    
    // ---- Texts ----
    const partDeliveryLabel =
      cUtil.customerPickUp()
      ? __('Schnellste Teilabholungen','custom')
      : __('Schnellste Teillieferungen','custom');

    this.button_partDelivery .textContent = partDeliveryLabel;
    this.button_updateCart   .textContent = __('Warenkorb speichern'       ,'custom');
    this.button_updateCart2  .textContent = __('Werte aktualisieren'       ,'custom');
    this.button_toCheckout   .textContent = __('Zur Kasse'                 ,'custom');
    this.button_sameDate     .textContent = __('Gesammelt liefern'         ,'custum');
    this.dt_weight           .textContent = __('Gesamtgewicht'             ,'custom');
    this.span_weightCa       .textContent = __('ca. '                      ,'custom');
  
    // ---- Classes ----
    this.button_partDelivery .classList.add('c-button-simple-light', 'button_partDelivery');
    this.button_updateCart   .classList.add('c-button-simple-light', 'button_updateCart');
    this.button_updateCart2  .classList.add('c-button-simple-light');
    this.button_toCheckout   .classList.add('c-button-simple');
    this.div_messagesErrors  .classList.add('c-cart-messages', 'div_messagesErrors');
    this.span_weightCa       .classList.add('c-ca');
    
    // ---- Other ----
    this.button_partDelivery .type = 'button';
    this.button_updateCart   .type = 'submit';
    this.button_updateCart2  .type = 'submit';
    this.button_toCheckout   .type = 'submit';
    this.button_partDelivery .type = 'button';
    this.input_submitData    .type = 'hidden';
    this.input_submitData    .name = 'c-json-cart';

    // ---- Tab Index ----
    // Wie in der Bestellliste: pro Artikel Lieferdatum vor der Menge, sonst gälte die Reihenfolge im
    // DOM, wo das Lieferdatum hinter der Menge steht. Auch Enter folgt dieser Reihenfolge.
    this.commonDeliveryDate.setTabIndex(1);
    this.items.forEach((item, index) => item.setTabIndex((index + 1) * 100));

    // ---- Init ----
    this.button_updateCart2.classList.add('c-hidden');

    this.changeEvent('cCart init');

    // ---- Events ----
    cUtil.enterToNextField(this.form);

    this.button_partDelivery.addEventListener('click', () => {
      this.items.forEach(item => {
        const date = item.inputData.product.deliveryDates.validDates.at(0);
        if (date === undefined) return;
        item.setDeliveryDate(date); 
      });
      this.setCommonDateSelector();
      this.changeEvent('partDelivery');
    });

    this.button_updateCart.addEventListener('click', (e: Event) => {
      e.preventDefault();
      const isValid = this.validateItems();
      if(isValid) {
        this.setSubmitData('save');
        this.form.submit();
      };
    });
    this.button_updateCart2.addEventListener('click', (e: Event) => {
      e.preventDefault();
      const isValid = this.validateItems();
      if(isValid) {
        this.setSubmitData('save');
        this.form.submit();
      };
    });

    this.button_toCheckout.addEventListener('click', (e: Event) => {
      e.preventDefault();
      const isValid = this.validateItems();
      if(isValid) {
        this.setSubmitData('checkout');
         if ('requestSubmit' in HTMLFormElement.prototype) {
           this.form.requestSubmit()
         }
         else {
          this.form.submit();
         }
      };
    });

    this.button_sameDate.addEventListener('click', (e: Event) => {
      e.preventDefault();

      const date = 
        this.getCommonValidDates()
        .at(0);

      if (date === undefined) return;

      this.commonDeliveryDate.setDate(date);
      this.changeEvent('sameDelivery');
    });

  }


  // ---------------- Public ----------------
  changeEvent(eventSource: string): void {
    if (eventSource === 'cCart init') {
      this.commonDeliveryDate.setValidDates(this.getCommonValidDates());
      this.setCommonDateSelector();
      this.validateItems();
      this.updateTotalAmount(true);
    }
    if (eventSource === 'commonDeliveryDate') {
      const date = this.commonDeliveryDate.getDate();
      this.items.forEach(item => item.setDeliveryDate(date));
      this.validateItems();
      this.updateTotalAmount();
    }
    if (eventSource === 'cProductItemDeliveryDate_constructor_dateFieldDefault') {
      this.setCommonDateSelector();
      this.validateItems();
      this.updateTotalAmount();
    }
    if (eventSource === 'cProductItemAmounts_change') {
      this.validateItems();
      this.updateTotalAmount();
    }
    if (eventSource === 'cProductItemMarinades_change') {
      this.validateItems();
      this.updateTotalAmount();
    }
    if (eventSource === 'partDelivery') {
      this.validateItems();
      this.updateTotalAmount();
    }
    if (eventSource === 'sameDelivery') {
      const date = this.commonDeliveryDate.getDate();
      this.items.forEach(item => item.setDeliveryDate(date));
      this.validateItems();
      this.updateTotalAmount();
    }
  }

  validateItem(silent: 'silent'|'', message: 'list'|'', isSelected?: boolean): boolean {
    return true;
  }

  deleteItem(itemId: string) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    this.items =
      this.items
      .filter(item => item.inputData.item.item_id !== itemId);

    const message = __('Das Element wurde gelöscht', 'custom');

    this.addError(message, 'success');
  }

  // Changes of the other items, saved together with a deletion — the page is reloaded afterwards.
  // Invalid items are left out, the server keeps their saved state.
  getSaveData(deletedItemId: string): string {
    const cart: CartReturnData = {
      type  : 'save',
      items :
        this.items
        .filter(item => item.inputData.item.item_id !== deletedItemId)
        .filter(item => item.validateItem('silent', ''))
        .map(item => item.getData()),
    }
    return JSON.stringify(cart);
  }

  setErrorMessage(message: string) {
    this.addError(message, 'alert');
    this.displayErrors();
  }

  // ---------------- Private Methods ----------------
  
  private setCommonDateSelector() {
    const allDates = this.items.map(item => item.getDeliveryDate());
    const firstDate = allDates.find(date => date !== undefined);
    if (firstDate === undefined) return;

    const allIdentical =
      allDates.length === 1 ||
      allDates.every((value, index, allDates) => value === firstDate);

    const newDate = allIdentical ? firstDate : '';
    this.commonDeliveryDate.setDate(newDate);
  }

  private setSubmitData(type: 'save' | 'checkout') {
    const cart: CartReturnData = {
      type  : type,
      items : this.items.map(item => item.getData()),
    }
    this.input_submitData.value = JSON.stringify(cart);
  }

  private getCommonValidDates(): string[] {

    const dateArrays =
      this.items
      .map(item => item.inputData.product.deliveryDates.validDates);

    const dateSets =
      dateArrays.map((arr) => new Set(arr));

    const [smallestSet, ...otherSets] = dateSets.sort((a, b) => a.size - b.size);
    if (smallestSet === undefined) return [];
    
    const smallest = Array.from(smallestSet.values())
    return smallest.filter(val => otherSets.every(set => set.has(val)));
  }

  private validateItems(): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    this.clearErrors();

    const isValidDel =
      this.items
      .filter(item => item.inputData.item.sku === 'none')
      .length === 0;

    if (!isValidDel) {
      const messageDel = __('Der Warenkorb enthält gelöschte Produkte', 'custom');
      this.addError(messageDel, 'warning');
    }

    const hasMultipleDates = 
      !this.items
      .map(item => item.getDeliveryDate())
      .every((date, index, array) => date === array[0]);

    if (hasMultipleDates) {
      const messageDel = __('Ihr Warenkorb enthält mehrere Lieferdaten. Fassen Sie alles zu einer Lieferung zusammen – das vereinfacht Ihre Warenannahme und schont Ressourcen. Geliefert wird, sobald der zuletzt verfügbare Artikel bereitsteht', 'custom');
      this.addError(messageDel, 'warning-date');
    }

    const isValidCommonDeliveryDate = this.validateCommonDeliveryDate();
    const isValidMinimumAmount      = this.validateMinimumAmount();
    // this.validateItemOrigin();

    const isValidItems =
      this.items
      .map(item => item.validateItem('', ''))
      .filter(item => item === false)
      .length === 0;

    if (!isValidItems || !isValidCommonDeliveryDate) {
      const messageItem = __('Dieser Warenkorb enthält fehlerhafte Eingaben.', 'custom');
      this.addError(messageItem, 'alert');
    }
    
    const isValid = 
      isValidItems &&
      isValidCommonDeliveryDate &&
      isValidMinimumAmount;

    if (!isValid) {
      this.button_updateCart.disabled  = true;
      this.button_updateCart2.disabled = true;
      this.button_toCheckout.disabled  = true;
    }
    else {
      this.button_updateCart.disabled  = false;
      this.button_updateCart2.disabled = false;
      this.button_toCheckout.disabled  = false;
    }

    this.displayErrors();
    return isValid;
  }

  private validateCommonDeliveryDate() {
    return this.commonDeliveryDate.validateItem('', 'list');
  }

  private validateMinimumAmount() {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    const dates = new Map();
    for(const item of this.items) {
      const date       = item.getData().delivery_date;
      const amountData = item.productItem.amounts.calculateAmounts();
      const totalPrice = amountData.totalAmount * amountData.price;

      const value = dates.get(date) ?? 0;
      dates.set(date, value + totalPrice);
    }

    const errorMsg = __('Ihr aktueller Bestellwert liegt am %s bei CHF %s — Sie müssen eine Bestellung mit einem Mindestwert von CHF %s aufgeben.', 'custom');
    const minimum  = 0; // see also cart/functions.php checkMimimumOrderAmount()

    let isValid = true;
    for(const [key, value] of dates) {
      if (value < minimum) {
        const error = sprintf(errorMsg, cUtil.isoToCh(key), value.toFixed(2), String(300));
        this.addError(error, 'alert');
        isValid = false;
      }
    }

    return isValid;
  }

  // private validateItemOrigin() {
  //   const { __, _x, _n, sprintf } = wp.i18n as i18n;
  //   const hasListItems =
  //     this.input.items
  //     .filter(item => item.orderListName !== '')
  //     .length >= 1;

  //   const hasDirectItems =
  //     this.input.items
  //       .filter(item => item.orderListName === '')
  //       .length >= 1;

  //   const mixed   = hasDirectItems && hasListItems;
  //   const message = mixed ? __('Warenkorb enthält Produkte die nicht von einer Bestellliste kommen.', 'custom') : '';

  //   if (message !== '') {
  //     this.addError(message, 'warning');
  //   }
  // }

  private updateTotalAmount(init: boolean = false) {
    if (!init) {
      this.button_updateCart2.classList.remove('c-hidden');
    }

    const totalWeight =
      this.items
        .map(item => item.productItem.amounts.getWeight())
        .reduce((sum, item) => sum + item, 0)
        .toFixed(3);

    this.span_weightAmount.textContent = `${totalWeight} Kg`;
  }

  private addError(text: string, type: 'alert'|'warning'|'info'|'success'|'warning-date') {
    this.errors.add({msg: text, type: type});
  }
  private clearErrors() {
    this.errors.clear();
  }
  private displayErrors() {
    this.div_messagesErrors.replaceChildren();
    for(let error of this.errors) {
      const p_error = document.createElement('p');
      p_error.textContent = error.msg;

      const typeClass =
        error.type === 'alert'        ? 'c-alert'   :
        error.type === 'warning'      ? 'c-warning' :
        error.type === 'info'         ? 'c-info'    :
        error.type === 'success'      ? 'c-success' :
        error.type === 'warning-date' ? 'c-warning' :
        /*else*/                      'c-info'    ;
      
      p_error.classList.add(typeClass, 'c-cart-messages');
      if (error.type === 'warning-date') {
        p_error.append(this.button_sameDate);
      }

      this.div_messagesErrors.append(p_error);
    }
  }
}
